// client/src/components/wetakeover/HeroSection.jsx
import React from 'react';

const HeroSection = ({ onBuildCampaign }) => {
  return (
    <div className="ui-motion-enter max-w-6xl mx-auto rounded-[40px] md:rounded-[56px] bg-zinc-950/80 backdrop-blur-xl shadow-[0_30px_120px_rgba(0,0,0,0.75)] border border-white/10 p-6 md:p-8 lg:p-10 relative mb-16">

      {/* Glow Overlays */}
      <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-white/10 blur-[120px] pointer-events-none" />
      <div className="absolute -bottom-40 -right-40 h-[520px] w-[520px] rounded-full bg-yellow-300/8 blur-[120px] pointer-events-none" />

      {/* Google Font for Logo */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Saira+Extra+Condensed:wght@900&display=swap');
        .takeover-logo {
          font-family: 'Saira Extra Condensed', sans-serif;
          font-weight: 900;
        }
      `}</style>

      {/* Nav Bar */}
      <nav className="flex items-center justify-between mb-8 relative z-10">
        <div className="takeover-logo text-3xl md:text-4xl text-[#e4ca00] tracking-tight leading-none">TAKEOVER</div>
        <button
          onClick={onBuildCampaign}
          className="rounded-full bg-yellow-300 px-6 py-3 text-sm font-semibold text-black shadow-[0_15px_40px_rgba(250,204,21,0.2)] hover:shadow-[0_20px_50px_rgba(250,204,21,0.4)] transition-shadow"
        >
          Launch Campaign
        </button>
      </nav>

      {/* Hero Copy */}
      <div className="text-center mb-10 relative z-10">
        <h1 className="text-4xl md:text-6xl lg:text-7xl leading-[1.05] font-extrabold text-white mb-6">
          AMPLIFY YOUR
          <br />
          <span className="text-yellow-300">REACH</span>
        </h1>
        <p className="text-xl text-white/60 mb-10 max-w-2xl mx-auto">
          We deliver content Amplification campaigns for the biggest brands in WEB3
        </p>
        <button
          onClick={onBuildCampaign}
          className="rounded-full bg-yellow-300 px-8 py-4 text-lg font-semibold text-black shadow-[0_15px_40px_rgba(250,204,21,0.2)] hover:shadow-[0_20px_50px_rgba(250,204,21,0.4)] motion-safe:hover:-translate-y-0.5 transition-[box-shadow,transform]"
        >
          AMPLIFY YOUR CONTENT NOW!
        </button>
      </div>

      {/* Stats Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative z-10">
        <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl p-8 hover:border-white/20 transition-colors">
          <div className="text-4xl font-bold text-yellow-300 mb-2">5M+</div>
          <div className="text-white/60">Total Reach</div>
        </div>
        <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl p-8 hover:border-white/20 transition-colors">
          <div className="text-4xl font-bold text-yellow-300 mb-2">200+</div>
          <div className="text-white/60">Campaigns Launched</div>
        </div>
        <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl p-8 hover:border-white/20 transition-colors">
          <div className="text-4xl font-bold text-yellow-300 mb-2">&lt;24hr</div>
          <div className="text-white/60">Deliver Content</div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
